import santander_logo from '../styles/icons/Logo-Santander.svg'
import Getnet_logo from '../styles/icons/Getnet.svg'
import Aquanima_logo from '../styles/icons/Aquanima.svg'
import Prospera_Santander_logo from '../styles/icons/Prospera_Santander.svg'
import AssetManagement_Extended_logo from '../styles/icons/Santander_AssetManagement_Extended.svg'
import CIB_Compact_logo from '../styles/icons/Santander_CIB_Compact.svg'
import ConsumerBank_Extended_logo from '../styles/icons/Santander_ConsumerBank_Extended.svg'
import ConsumerFinance_Extended_logo from '../styles/icons/Santander_ConsumerFinance_Extended.svg'
import Santander_Digital_Services from '../styles/icons/Santander_Digital_Services.svg'
import Santander_Empresas_Extended_logo from '../styles/icons/Santander_Empresas_Extended.svg'
import Santander_Fundacion from '../styles/icons/Santander_Fundacion.svg'
import OneTrade_Extended_logo from '../styles/icons/Santander_OneTrade_Extended.svg'
import PrivateBankingt_Extended_logo from '../styles/icons/Santander_PrivateBankingt_Extended.svg'
import Select_Extended_logo from '../styles/icons/Santander_Select_Extended.svg'
import Tuiio_logo from '../styles/icons/Tuiio.svg'

export const LOGOS = [
  {
    id: 'santander_logo',
    label: 'Santander',
    svg: santander_logo,
  },
  {
    id: 'Aquanima_logo',
    label: 'Aquanima',
    svg: Aquanima_logo,
  },
  {
    id: 'Getnet_logo',
    label: 'Getnet',
    svg: Getnet_logo,
  },
  {
    id: 'Prospera_Santander_logo',
    label: 'Prospera Santander',
    svg: Prospera_Santander_logo,
  },
  {
    id: 'AssetManagement_Extended_logo',
    label: 'AssetManagement',
    svg: AssetManagement_Extended_logo,
  },
  {
    id: 'CIB_Compact_logo',
    label: 'CIB',
    svg: CIB_Compact_logo,
  },
  {
    id: 'ConsumerBank_Extended_logo',
    label: 'ConsumerBank',
    svg: ConsumerBank_Extended_logo,
  },
  {
    id: 'ConsumerFinance_Extended_logo',
    label: 'ConsumerFinance',
    svg: ConsumerFinance_Extended_logo,
  },
  {
    id: 'Santander_Digital_Services',
    label: 'Digital Services',
    svg:   Santander_Digital_Services
  },
  {
    id: 'Santander_Empresas_Extended_logo',
    label: 'Santander Empresas',
    svg: Santander_Empresas_Extended_logo,
  },
  {
    id: 'Santander_Fundacion_logo',
    label: 'Santander Fundación',
    svg: Santander_Fundacion,
  },
  {
    id: 'OneTrade_Extended_logo',
    label: 'OneTrade',
    svg: OneTrade_Extended_logo,
  },
  {
    id: 'PrivateBankingt_Extended_logo',
    label: 'Private Banking',
    svg: PrivateBankingt_Extended_logo,
  },
  {
    id: 'Select_Extended_logo',
    label: 'Select',
    svg: Select_Extended_logo,
  },
  {
    id: 'Tuiio_logo',
    label: 'Tuiio',
    svg: Tuiio_logo,
  },
]

export function setFills(svg, color) {
  svg.childNodes.forEach(node => {
    if (node.getAttribute && node.getAttribute('fill')) {
      node.setAttribute('fill', color)
    }
    setFills(node, color)
  })
}